import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{attrs:{"tile":"","type":"error"}},[_vm._v(" The page you're looking for does not exist.")])
}
var staticRenderFns = []

export { render, staticRenderFns }